import { Children } from 'react'
import AppProviderBasic from '../sidebar/sidebar'
import InfoModal from '../infoModal/infoModal'
export default function Base({ children }) {
  return (
    <div className="">
      <InfoModal />
      <AppProviderBasic>
        {Children.map(children, (child) => (
          <div className="">{child}</div>
        ))}
      </AppProviderBasic>
    </div>
  )
}
